import { Button, Link } from "@wootingkb/component-library";
import { useDisclosure } from "../../../utils/hooks/useDisclosure";
import { useInServer } from "./hooks/useInServer";
import useRefreshRewards from "./hooks/useRefreshRewards";
import RewardsModal from "./modals/RewardsModal";
import { discordInvite } from "./utils";
import { Trans } from "@lingui/react/macro";

export function CTAButtons() {
  const { inServer, isLoading: isInServerLoading } = useInServer();
  const { onOpen, onClose, isOpen, onOpenChange } = useDisclosure();
  const { refreshRewards, isLoading, newRoles } = useRefreshRewards(onOpen);

  return !inServer ? (
    <Link href={discordInvite} external hideExternalIcon>
      <Button variant="secondary" size="sm" isLoading={isInServerLoading}>
        <Trans id="Discord_join_server_button">Join Discord Server</Trans>
      </Button>
    </Link>
  ) : (
    <>
      <Button
        variant="secondary"
        size="sm"
        isLoading={isLoading}
        onClick={refreshRewards}
      >
        <Trans id="Discord_refresh_rewards_button">Refresh rewards</Trans>
      </Button>

      {isOpen && (
        <RewardsModal
          isOpen={isOpen}
          onClose={onClose}
          onOpenChange={onOpenChange}
          newRoles={newRoles}
        />
      )}
    </>
  );
}
